import Button from './Button'
import { wideButtonStyles, increasedSidePadding } from './Button.styles'
export { wideButtonStyles, increasedSidePadding }
export default Button
export type { IButtonProps, Variant } from './Button.types'
